<div class="flex flex-col p-4 pb-4 overflow-hidden">
    <div mat-dialog-content id="dialog-change-password">
        
        <h3 class="text-xl text-gray-800 mb-4">Cambiar Contraseña</h3>
        <form [formGroup]="passwordForm" novalidate 
        >
        
            <div class="flex flex-col gt-xs:flex-row">
            <mat-form-field 
                
                class="flex-auto gt-xs:pr-3">
                <mat-label>Contraseña Actual</mat-label>
                <input type="password" matInput formControlName="password" autocomplete="off">
                
                <mat-error *ngIf="passwordForm.controls['password'].errors?.required">
                    Campo Obligatorio
                </mat-error>
            </mat-form-field>
    
            <mat-form-field 
                
                class="flex-auto gt-xs:pr-3">
                <mat-label>Nueva contraseña</mat-label>
                <input matInput type="password" formControlName="newPassword" autocomplete="off">
                
                <mat-error *ngIf="passwordForm.controls['newPassword'].errors?.required">
                    Campo Obligatorio
                </mat-error>
                <mat-error *ngIf="passwordForm.controls['newPassword'].errors?.minlength">
                    Se requieren mínimo {{ passwordForm.controls['newPassword'].errors.minlength.requiredLength }} caracteres.
                </mat-error>
                <mat-error *ngIf="passwordForm.controls['newPassword'].errors?.maxlength">
                    Máximo se permiten {{ passwordForm.controls['newPassword'].errors.maxlength.requiredLength }} caracteres.
                </mat-error>
            </mat-form-field>
    
            <mat-form-field 
                
                class="flex-auto gt-xs:pr-3">
                <mat-label>Repetir contraseña</mat-label>
                <input matInput type="password" formControlName="passwordConfirm" autocomplete="off">
                
                <mat-error *ngIf="passwordForm.controls['passwordConfirm'].errors?.required">
                    Campo Obligatorio
                </mat-error>

                <mat-error *ngIf="passwordForm.get('passwordConfirm').hasError('mustMatch')">
                    Las contraseñas no son iguales
                </mat-error>
            </mat-form-field>
    
            <span *ngIf="erroPasswordActual">Ups... parece ser que su contraseña actual es incorrecta.
                Por favor revise nuevamente su contraseña actual.</span>
            </div>
        </form>
  
    </div>
  
    <div class="flex justify-between">
      <button mat-button color="primary" aria-label="cancelar" (click)="cancelUpdate()">
        Cancelar
      </button>
  
      <button mat-raised-button color="accent" aria-label="Actualizar passwors"
        [disabled]="!passwordForm.valid || updatingPassword" (click)="updatePassword()">
        <mat-icon
        class="icon-size-5 text-white animate-spin-slow mr-2"
        [svgIcon]="'mat_solid:sync'"></mat-icon>
        Actualizar
      </button>
    </div>
  </div>